<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="form.covid_form_name+' [Custom Form] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/custom-forms`">
                            <i class="fa fa-file-text"></i> Custom Forms
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ form.covid_form_name }}
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-lg-8 col-12">
                    <personnel-form ref="customFormPersonnelForm" :initialPersonnel="personnel" />

                    <incident-sections-builder
                        :sections="previewSections"
                        :personnel="personnel"
                        labelSize="col-md-3 col-12 text-md-right text-muted"
                        fieldSize="col-md-7 col-12" />

                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Sign and Date:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-4">
                                <div class="col-md-3 col-12 text-md-right text-muted">
                                    Jobsite: <i class="fa fa-asterisk text-danger" v-if="form.require_jobsite"></i>
                                </div>
                                <div class="col-md-8 col-12">
                                    <jobsite-select ref="jobsiteSelector"></jobsite-select>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-3 col-12 text-md-right text-muted">Employee Or Visitor: <i class="fa fa-asterisk text-danger"></i></div>
                                <div class="col-md-8 col-12">
                                    <b-form-radio-group v-model="person_or_employee" :options="[{text: 'Employee', value: 'Employee'}, {text: 'Visitor', value: 'Visitor'}]" plain></b-form-radio-group>
                                </div>
                            </div>
                            <div class="row mb-4" v-if="person_or_employee == 'Visitor'">
                                <div class="col-md-3 col-12 text-md-right text-muted">Visitor: <i class="fa fa-asterisk text-danger"></i></div>
                                <div class="col-md-8 col-12">
                                    <b-form-input placeholder="Enter Visitor Name"></b-form-input>
                                </div>
                            </div>
                            <div class="row mb-4" v-if="person_or_employee == 'Employee'">
                                <div class="col-md-3 col-12 text-md-right muted">Employee: <i class="fa fa-asterisk text-danger"></i></div>
                                <div class="col-md-8 col-12">
                                    <employee-select ref="employeeSelector"></employee-select>
                                </div>
                            </div>

                            <label>Signature:</label>
                            <VueSignaturePad ref="sigPad" class="signature-pad" />
                        </div>
                        <div class="card-footer" v-if="false">
                            <button class="btn btn-success">Complete Form</button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Form Settings</strong>
                            <div class="pull-right">
                                <router-link :to="`/custom-forms/forms/edit/${form.id}`" class="btn btn-sm btn-light" v-if="$root.hasPermission('custom_forms.manage')">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/custom-forms/entry/create?form_id=${form.id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-plus-circle text-success"></i> Entry
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-lg-4 text-lg-right text-muted">Name:</div>
                                <div class="col-lg-8">
                                    {{ form.covid_form_name }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-4 text-lg-right text-muted">Require Jobsite:</div>
                                <div class="col-lg-8">
                                    {{ form.require_jobsite ? 'Yes' : 'No' }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-4 text-lg-right text-muted">Enable Public Access:</div>
                                <div class="col-lg-8">
                                    {{ form.enable_public_access ? 'Yes' : 'No' }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-4 text-lg-right text-muted">Enable Guest Access:</div>
                                <div class="col-lg-8">
                                    {{ form.enable_guest_access ? 'Yes' : 'No' }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-4 text-lg-right text-muted">Require Access Password:</div>
                                <div class="col-lg-8">
                                    {{ form.req_public_form_password ? 'Yes' : 'No' }}
                                </div>
                            </div>
                            <div class="row mb-2" v-if="form.req_public_form_password == 1">
                                <div class="col-lg-4 text-lg-right text-muted">Public Access Password:</div>
                                <div class="col-lg-8">
                                    <div v-if="show_access_pass">{{ form.public_form_password }}</div>
                                    <div v-else>
                                        [Redacted] <a href="javascript:void(0)" v-on:click="showAccessPass()">Click to View</a>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-4 text-lg-right text-muted">Require Signature:</div>
                                <div class="col-lg-8">
                                    {{ form.require_employee_sig ? 'Yes' : 'No' }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4" v-if="form.enable_public_access === 1">
                        <div class="card-header">
                            <i class="fa fa-unlock"></i> Public Access
                        </div>
                        <div class="card-body">
                            <qr-code
                                :qr_code_url="`${$root.appUrl}/custom-forms/access/${form.custom_form_key}/edit`"
                                :qr_code_name="'Custom-Form-'+form.form_name"
                                :show_url="true" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/css">
    .signature-pad {
        width: 100%;
        height: 300px;
        border: 1px solid #ddd;
    }
</style>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                show_access_pass: false,
                person_or_employee: null,
                id: this.$route.params.id,
                form: {},
                covid_fields: [],
                entry: {},
                personnel: [],
            }
        },

        computed: {
            previewSections(){
                //Setup
                var covid_fields = [];

                //Loop through and build lists
                for(var i = 0; i < this.covid_fields.length; i++)
                {
                    //Close it
                    var sec = JSON.parse(JSON.stringify(this.covid_fields[i]));

                    //Unset the base section
                    delete sec.base_section;

                    //Push onto options
                    covid_fields.push(sec);
                }

                //Send it
                return covid_fields;
            }
        },

        methods: {

            getForm() {
                //Get the data
                this.$http
                    .get('/custom-forms/forms/view/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.form = response.data.form;
                        this.covid_fields = this.form.covid_fields ? this.form.covid_fields : [];
                        this.personnel = response.data.personnel;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            showAccessPass(){
                //Set it
                this.show_access_pass = true;

                //Set the timeout
                setTimeout(() => {
                    //Set it
                    this.show_access_pass = false;
                }, 6000);
            }

        },
        mounted() {
            //Get the Safety Meeting
            this.getForm();
        }
    }
</script>
